import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 15a9 9 0 1 1 18.001.001A9 9 0 0 1 5 15z",
      stroke: "#1e3951",
      "stroke-width": "3",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#55acba",
      d: "M1 13h9v4H1zm17 0h9v4h-9zM12 2h4v9h-4zm0 17h4v9h-4z"
    }, null, -1)
  ])))
}
export default { render: render }